import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
export function useHasLinkedAccounting() {
    const isLinkedToQbo = useStore(selectors.integration.isLinkedToQbo);
    const isLinkedToXero = useStore(selectors.integration.isLinkedToXero);
    return isLinkedToQbo || isLinkedToXero;
}
